module.exports = __webpack_public_path__ + "static/media/S1N13-1.422b900a.svg";